(function ($) {
  DJ.addBehavior('brioTooltip', '.js-tooltip', {
    attach: function () {
      const tooltip = this;
      const tooltipBtn = tooltip.querySelector('.tooltip-btn');
      const tooltipContent = tooltip.querySelector('.tooltip');
      const tooltipShowClass = 'tooltip--show';
      let tooltipEventTypeUp = 'mouseup';
      let tooltipEventTypeDown = 'mousedown';

      if (DJ.isTouch) {
        tooltipEventTypeUp = 'touchend';
        tooltipEventTypeDown = 'touchstart';
      }

      /**
       * Return false if no tooltip content.
       */
      if (!tooltipContent && !tooltipBtn) {
        return false;
      }

      /**
       * Close tooltip.
       */
      const closeTooltip = () => {
        tooltipContent.classList.remove(tooltipShowClass);

        $('body').off(`${tooltipEventTypeUp}.bodyBrioTooltip`);
        tooltipBtn.setAttribute('aria-expanded', false);

        $(tooltip).append(tooltipContent);
      };

      /**
       * Open tooltip.
       */
      const showTooltip = () => {
        tooltipContent.classList.add(tooltipShowClass);

        const leftPosition = tooltipBtn.getBoundingClientRect().left;
        const leftMargin = (tooltipContent.offsetWidth / 2) - (tooltipBtn.offsetWidth / 2);
        const topPosition = tooltipBtn.getBoundingClientRect().bottom;

        tooltipBtn.setAttribute('aria-expanded', true);
        tooltipContent.style.top = `${topPosition + window.pageYOffset}px`;
        tooltipContent.style.left = `${leftPosition}px`;
        if (DJ.bp.name === 'mobile') {
          tooltipContent.style.marginLeft = `-${leftMargin - 20}px`;
        } else {
          tooltipContent.style.marginLeft = `-${leftMargin}px`;
        }

        $('body').append(tooltipContent);
        $(tooltipBtn).off('keydown.tooltipBtn');
        $(tooltipBtn).on('keydown.tooltipBtn', (e) => {
          if (e.keyCode === 9) {
            const toolTipCtaOnKeyDown = document.querySelector('.tooltip--show .tooltip__cta');

            if (toolTipCtaOnKeyDown) {
              e.preventDefault();

              toolTipCtaOnKeyDown.focus();

              setTimeout(() => {
                $(tooltipBtn).off('keydown.tooltipBtn');
              }, 0);
            }
          }
        });

        const toolTipCta = document.querySelector('.tooltip--show .tooltip__cta');
        $(toolTipCta).off('keydown.toolTipCta');
        $(toolTipCta).on('keydown.toolTipCta', (ctaE) => {
          if (ctaE.keyCode === 9) {
            ctaE.preventDefault();
            tooltipBtn.focus();
            closeTooltip();

            setTimeout(() => {
              $(toolTipCta).off('keydown.toolTipCta');
            }, 0);
          }
        });
      };

      /**
       * Close on body click.
       */
      const onBodyClick = () => {
        $('body').on(`${tooltipEventTypeUp}.bodyBrioTooltip`, (e) => {
          if (!($(e.target).closest('.tooltip').length)) {
            closeTooltip();
          }
        });
      };

      /**
       * Bind open/close on button mousedown/touchstart.
       */
      tooltipBtn.addEventListener(tooltipEventTypeDown, () => {
        if (!tooltipContent.classList.contains(tooltipShowClass)) {
          showTooltip();
        } else {
          closeTooltip();
        }
      });

      /**
       * Bind open/close on button keydown.
       */
      tooltipBtn.addEventListener('keydown', (e) => {
        if (e.keyCode === 32 || e.keyCode === 13) {
          e.preventDefault();

          if (!tooltipContent.classList.contains(tooltipShowClass)) {
            showTooltip();
          } else {
            closeTooltip();
          }
        }
      });

      /**
       * Bind body close on button keyup.
       */
      tooltipBtn.addEventListener('keyup', (e) => {
        if (e.keyCode === 32 || e.keyCode === 13) {
          if (tooltipContent.classList.contains(tooltipShowClass)) {
            setTimeout(() => {
              onBodyClick();
            }, 50);
          }
        }
      });

      /**
       * Bind body close on button mouseup/touchend.
       */
      tooltipBtn.addEventListener(tooltipEventTypeUp, () => {
        if (tooltipContent.classList.contains(tooltipShowClass)) {
          setTimeout(() => {
            onBodyClick();
          }, 50);
        }
      });

      return true;
    }
  });
})(jQuery);
